import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// o8C7m1VgU5tQOoxyvilbbINae0z8
export default new Vuex.Store({
    state: {
        // 后端的登录凭证
        token: '',
        // 是否在微信浏览器中
        inWx: false,
        // 昵称
        nickname: '',
        // 头像
        avatarUrl: '',
        openID: '',
        unionID: '',
        // 是否已经关注公众号
        subscribeIng: false,
        // 微信的skd 是否已经 初始完成
        initWxSdkOk: false,
        // 售后使用的token
        maintenanceToken: '',
    },
    getters: {},
    mutations: {
        setAny(state, obj) {
            if (obj && typeof obj === 'object') {
                Object.keys(obj).forEach((key) => {
                    state[key] = obj[key];
                });
            }
        },
    },
    actions: {},
    modules: {},
});
